import { ref, onMounted, onBeforeUnmount } from "vue";
const useIsMounted = () => {
  const isMounted = ref(false);
  onMounted(() => {
    isMounted.value = true;
  });
  onBeforeUnmount(() => {
    isMounted.value = false;
  });
  return isMounted;
};
export {
  useIsMounted as u
};
//# sourceMappingURL=useIsMounted-a63f9559.mjs.map
